import {LocaleContextType} from '../../../provider/locale/locale-context-type';
import {
    BULK_EDIT_COMPANY_VIDEOS_FIELD,
    BulkEditCompaniesMainFilterType,
    BulkEditFieldNameEnum,
    BulkUpdateCompaniesFieldsType,
    BulkUpdateCompaniesFilterType,
} from '../../../service/company/company-type';
import {SELECTED_ALL} from '../my-companies/companies-table/companies-table-const';

import {serializeFieldByFieldName, validateFieldByFieldName} from './bulk-edit-companies-const';
import {BulkEditFieldType, BulkUpdateCompaniesErrorsType} from './bulk-edit-companies-type';
import {BulkEditFieldsFormType} from './fields-list/fields-list-type';

export function serializeBulkEditCompaniesFields(
    fieldsValues: BulkEditFieldsFormType,
    fields: Array<BulkEditFieldType>
): BulkUpdateCompaniesFieldsType {
    const serializedFields: BulkUpdateCompaniesFieldsType = {};

    fields.forEach((field) => {
        const serializedField = serializeFieldByFieldName(fieldsValues, field);

        if (field.name !== BulkEditFieldNameEnum.gallery) {
            Object.assign(serializedFields, {[field.name]: serializedField[field.name]});
            return;
        }

        // Photos and videos share one field but travel under their own field_set keys. An empty key is not sent:
        // "replace" with an empty list would wipe the photos of every company when only a video was uploaded
        // (and the videos when only photos were), which is how the field worked before videos joined it.
        const gallery = serializedField[BulkEditFieldNameEnum.gallery];
        const videos = serializedField[BULK_EDIT_COMPANY_VIDEOS_FIELD];

        if (gallery && gallery.value.length > 0) {
            serializedFields[BulkEditFieldNameEnum.gallery] = gallery;
        }

        if (videos && videos.value.length > 0) {
            serializedFields[BULK_EDIT_COMPANY_VIDEOS_FIELD] = videos;
        }
    });

    return serializedFields;
}

export function validateBulkEditCompaniesFields(
    fieldsValues: BulkEditFieldsFormType,
    fields: Array<BulkEditFieldType>,
    getLocalizedString: LocaleContextType['getLocalizedString']
): Partial<BulkUpdateCompaniesErrorsType> {
    const errors = {} as Record<
        BulkEditFieldNameEnum,
        BulkUpdateCompaniesErrorsType[keyof BulkUpdateCompaniesErrorsType]
    >;

    fields.forEach((field) => {
        errors[field.name] = validateFieldByFieldName(fieldsValues, getLocalizedString)[field.name];
    });

    return errors as Partial<BulkUpdateCompaniesErrorsType>;
}

function buildBulkEditFilterFromMainFilter(
    excludedIds: Array<number> | null,
    mainFilterKey: string
): BulkEditCompaniesMainFilterType {
    const filter: BulkEditCompaniesMainFilterType = {};

    filter.filter_key = mainFilterKey;

    if (excludedIds && excludedIds?.length > 0) {
        filter.exclude_ids = excludedIds;
    }

    return filter;
}

export function serializeBulkEditCompaniesFilters(
    companyIds: Array<number> | null,
    excludedIds: Array<number> | null,
    mainFilterKey: string
): BulkUpdateCompaniesFilterType {
    if (companyIds === null || companyIds.length === 0) {
        return buildBulkEditFilterFromMainFilter(excludedIds, mainFilterKey);
    }

    return {selected_ids: companyIds};
}

export function getBulkEditSelectedIdsForNavigation(
    selectedRows: Array<string> | typeof SELECTED_ALL,
    selectedCount: string,
    selectedCompaniesIds: Array<string>
): Array<string> | typeof SELECTED_ALL {
    if (selectedRows !== SELECTED_ALL) {
        return selectedRows;
    }

    if (selectedCount === '1' && selectedCompaniesIds.length === 1) {
        return selectedCompaniesIds;
    }

    return SELECTED_ALL;
}
